/* custom scrollbar */
const custom_slider = document.querySelectorAll('.c-saying-right, .p-material, .product-list-container, .pdp-why-does-skin-tab_container');
let isDown = false;
let startX;
let scrollLeft;
custom_slider?.forEach(element => customScrollBar(element))
function customScrollBar(element){
  element.addEventListener('mousedown', (e) => {
    isDown = true;
    element.classList.add('active');
    startX = e.pageX - element.offsetLeft;
    scrollLeft = element.scrollLeft;
  });
  element.addEventListener('mouseleave', () => {
    isDown = false;
    element.classList.remove('active');
  });
  element.addEventListener('mouseup', () => {
    isDown = false;
    element.classList.remove('active');
  });
  element.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - element.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    element.scrollLeft = scrollLeft - walk;
  })
}
/* end custom scrollbar */

/* brand-slider */
$('.slider-brand-image')?.slick({
  dots: false,
  infinite: true,
  speed: 200,
  slidesToShow: 4,
  centerMode: true,
  variableWidth: true, 
  autoplay: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        centerMode: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        centerMode: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        centerMode: true
      }
    }
  ]
});
$('.slider-brand-image').on('afterChange', function(event, slick, currentSlide) {
  var currentSlideId = 'slider-content-' + (currentSlide + 1);

  $('.slider-text-brand').each(function() {
    var dataId = $(this).attr('dataId');
    if (dataId === currentSlideId) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
    $('.slick-slide svg path').attr('fill', '#bcbcbc');
    $('.slider-brand-image .slick-current svg path').attr('fill', '#014548');
});
$('.slider-brand-image').slick('slickGoTo', 0);
/* end brand-slider */

/* people-trust */
$(".p-trust .no-f-n-content")?.length > 0 &&
  $(".p-trust .no-f-n-content").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    speed: 2000,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

/* meet-our-experts */
$(".m-o-experts-content")?.length > 0 &&
  $(".m-o-experts-content").slick({
    slidesToShow: 4.1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1230,
        settings: {
          slidesToShow: 3.1,
        },
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2.1,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  });

/* book-consultancy */
$(".consultation-s-content")?.length > 0 &&
  $(".consultation-s-content").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  });

/* other products */
$(".custom-metafield-product #product-grid").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: $(".next-arrow.slick-arrow"),
  nextArrow: $(".previous-arrow.slick-arrow"),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

/* product gallery */
$(".custo-slider").slick({
  dots: true,
  slidesToShow: 1.25,
  centerMode: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 1.4,
        centerMode: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1.5,
        centerMode: true,
      },
    },
  ],
});
$(".readmore").click(function (event) {
  event.preventDefault();
  $(".product-description-full").show();
  $(".product-description-short").hide();
});

$(".readless").click(function (event) {
  event.preventDefault();
  $(".product-description-full").hide();
  $(".product-description-short").show();
});

// code for blog view more button
document.addEventListener("DOMContentLoaded", function () {
  var viewMoreButton = document.getElementById("view-more-button");
  if (viewMoreButton) {
    viewMoreButton.addEventListener("click", function () {
      var nextPageUrl = this.getAttribute("data-next-page");
      if (nextPageUrl) {
        fetch(nextPageUrl)
          .then((response) => response.text())
          .then((data) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data, "text/html");
            var mainblog = document.querySelectorAll(".main-blog");
            var newArticles = doc.querySelectorAll(".blog-articles__article");
            var articlesContainer = document.getElementById(
              "blog-articles-container"
            );
            newArticles.forEach(function (article) {
              articlesContainer.appendChild(article);
            });
            var newNextPageUrl = doc
              .querySelector("#view-more-button")
              ?.getAttribute("data-next-page");
            if (newNextPageUrl) {
              viewMoreButton.setAttribute("data-next-page", newNextPageUrl);
            } else {
              console.log("remove_opacity", mainblog)
              viewMoreButton.style.display = "none";
              mainblog.forEach(function (blog) {
                blog.classList.add("remove_opacity");
              });
            }
          })
          .catch((error) =>
            console.error("Error fetching the next page:", error)
          );
      }
    });
  }
});
// end code for blog view more button

// popup ingredient
document.addEventListener("DOMContentLoaded", () => {
  let getpopup = document.querySelectorAll(".open-popup");
  let ingredient = document.querySelectorAll(".popup-ingredient");
  let closeBTn = document.querySelector(".close-button");
  let overlay = document.querySelectorAll(".PageOverlay");

  getpopup.forEach((item) => {
    item.addEventListener("click", () => {
      let getAttr = item.getAttribute("data-attr");
      ingredient.forEach((i) => {
        i.style.display = "none";
      });
      let getElement = document.getElementById(getAttr);
      let getElementoverlay = document
        .getElementById(getAttr)
        .closest(".PageOverlay");
      if (getElement) {
        getElement.style.display = "block";
      }
      getElementoverlay.style.display = "block";
      getElementoverlay.classList.add("overlaybg");
      let body = getElementoverlay.closest("body");
      body.style.overflow = "hidden";
    });
  });
 
  ingredient.forEach((closebtn) => {
    let getcrossbtn = closebtn.querySelector(".close-button");
    let getcrossbtnoverlay = closebtn.closest(".PageOverlay");
    getcrossbtn.addEventListener("click", () => {
      closebtn.style.display = "none";
      getcrossbtnoverlay.style.display = "none";
      getcrossbtnoverlay.classList.remove("overlaybg");
      let bodyremoveclass = getcrossbtnoverlay.closest("body");
      bodyremoveclass.style.overflow = "";
    });
     getcrossbtnoverlay.addEventListener("click", (event) => {
      // Ensure the click is on the overlay, not inside the popup
      if (event.target === getcrossbtnoverlay) {
        closePopup(closebtn, getcrossbtnoverlay);
      }
    });
    function closePopup(popup, overlay) {
    popup.style.display = "none";
    overlay.style.display = "none";
    overlay.classList.remove("overlaybg");

    let bodyremoveclass = document.body; // Get the body element directly
    bodyremoveclass.style.overflow = ""; // Remove overflow restriction
    }

  });
});

// end popup ingredient

// faq code
var getproducttab = document.querySelectorAll(".product_details");
getproducttab.forEach((item) => {
  let title = item.querySelector(".metatitle_svg");
  let faqIconPlus = item.querySelector(".metatitle_svg .plus-icon");
  let faqIconMinus = item.querySelector(".metatitle_svg .minus-icon");
  let content = item.querySelector(".metaContent");
  title.addEventListener("click", function () {
    if (!content.classList.contains("hideElement")) {
      content.classList.add("hideElement");
      faqIconPlus.style.display = "flex";
      faqIconMinus.style.display = "none";
    } else {
      getproducttab.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.querySelector(".metaContent").classList.add("hideElement");
          let otherPlusIcon = otherItem.querySelector(
            ".metatitle_svg .plus-icon"
          );
          let otherMinusIcon = otherItem.querySelector(
            ".metatitle_svg .minus-icon"
          );
          otherPlusIcon.style.display = "flex";
          otherMinusIcon.style.display = "none";
        }
      });
      content.classList.remove("hideElement");
      faqIconPlus.style.display = "none";
      faqIconMinus.style.display = "flex";
    }
  });
});

if ($(window).width() < 767) {
$(".footer-block__heading").click(function (e) {
  e.preventDefault();
  let $this = $(this);
  if ($this.hasClass("show-acc")) {
    $this.removeClass("show-acc");
    $this.next().slideUp(350);
  } else {
    $this.parent().parent().find(".footer-block__heading").removeClass("show-acc");
    $this.parent().parent().find(".footer-block__details-content").slideUp(350);
    $this.toggleClass("show-acc");
    $this.next().slideToggle(350);
  }
});
}
// end faq code
// footer code 
$("#back-to-top").click(function() {
  $("html, body").animate({ scrollTop: 0 }, "slow");
});

$('.ultimate_container').on('beforeChange', function(event, slick, currentSlide) {
  if ($(slick.$slides[currentSlide]).hasClass('slick-current')) {
      $(this).closest('.ultimate_purpose').removeClass('page-width');
  }
});
$('.ultimate_container').slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2500,
  speed: 700,
  arrows:false,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        centerMode: false
      }
    }
  ]
});

$('.ultimate_cstm_slider').slick({
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 700,
  arrows:false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.ultimate_gallery_slider').slick({
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 700,
  arrows:false,
  slidesToShow: 2,
  centerMode: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    }
  ]
});

//thumnails media
if($(window).width() > 750){
$('.ultimate_slider_desktop').slick({
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: true,
  autoplay: false,
  vertical: true,
  verticalSwiping: true,
  prevArrow: '<i class="fa fa-angle-up ultimate_you_previous" style="font-size:24px"></i>',
  nextArrow: '<i class="fa fa-angle-down ultimate_you_next" style="font-size:24px"></i>',
  responsive: [
    {
      breakpoint: 769,
      settings: {
      vertical: false,
      verticalSwiping: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      }
    }
    ]
});
};
//end thumnails media

//-----Add all to cart for pdp
$(document).on('click', '.ultimate_submit_button', function() {
    var ids = $(this).attr('var_id');
    ids = ids.replace(/,\s*$/, ''); 
    var idsArray = ids.split(',');

    // Select the cart notification or drawer element
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Create an array of items with their IDs and quantities
    var items = idsArray.map(function(productId) {
        return {
            id: productId,
            quantity: 1
        };
    });

    // Check if `this.cart` exists and get sections if applicable
    var sections = this.cart && this.cart.getSectionsToRender 
        ? this.cart.getSectionsToRender().map((section) => section.id) 
        : ["cart-drawer"];
    fetch(`/cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: items, sections: sections })
    }).then((response) => {
      return response.json();
    }).then((response) => {
      this.cart.renderContents(response);
    }).catch((error) => {
      console.log("Error adding items to the cart:", error);
    }).finally(() => {
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    })
  
    // $.ajax({
    //   type: 'POST',
    //   url: '/cart/add.js',
    //   data: JSON.stringify({ items: items, sections: sections }),
    //   contentType: 'application/json',
    //   dataType: 'json',
    //   success: function(data) {
    //      this.cart.renderContents(data);
    //   },
    //   error: function(error) {
    //     console.log("Error adding items to the cart:", error);
    //   }
    // });
});
//-----end Add all to cart for pdp

// $(document).ready(function(){


   

//   $(".apply-button").click(function () {
//     let targetP = $(this).closest(".promo-footer").prev().find(".promo-details p");
//     let promoText = targetP.text().trim();
//     let promoCode = promoText.split(':')[1]?.trim();

//     if (promoCode) {
//       applyDiscountToCart(promoCode);
//     }

//     $(".discount-section").css("display", "none");
//   });

//   function applyDiscountToCart(code) {
//     let discountUrl = `/discount/${code}`;
    
//     fetch(discountUrl)
//       .then(function(response) {
//         if (!response.ok) {
//           alert('Error applying discount');
//           return;
//         }
//         window.location.reload(); // Reload the page to reflect the updated cart
//       })
//       .catch(function(error) {
//         console.error('Error applying discount:', error);
//         alert('Error applying discount');
//       });
//   }

//   $(document).on('cart:updated', function() {
//     $(".more-offers").click(function () {
//       $(".discount-section").css("display", "block");
//     });

//     $(".close-offers").click(function () {
//       $(".discount-section").css("display", "none");
//     });

//     $(".apply-button").click(function () {
//       let targetP = $(this).closest(".promo-footer").prev().find(".promo-details p");
//       let promoText = targetP.text().trim();
//       let promoCode = promoText.split(':')[1]?.trim();

//       if (promoCode) {
//         applyDiscountToCart(promoCode);
//       }

//       $(".discount-section").css("display", "none");
//     });
//   });

 



  
//   // end code for cart discount
//  let targetNode = document.querySelector(".recommendation-product-cart .product-form .button");

// if (targetNode) {
//   // Set initial text
//   targetNode.innerText = "Add+";

//   // Observe changes to the text content
//   let observer = new MutationObserver(() => {
//     targetNode.innerText = "Add+";
//   });

//   observer.observe(targetNode, { childList: true, characterData: true, subtree: true });
// }


// });

//key ingredients
 $('.your-class-key-ingredient').slick({
  infinite: false,
  autoplaySpeed: 2000,
  arrows: true,
  slidesToShow: 4, // Default for desktop
  slidesToScroll: 1,
  dots: false,
  prevArrow: '<button type="button" class="slider-button slider-button--prev pdp_desktop_slider_icons"><svg xmlns="http://www.w3.org/2000/svg" width="69" height="70" viewBox="0 0 69 70" fill="none"><g filter="url(#filter0_b_9117_19427)"><circle cx="34.4563" cy="35.4561" r="33.6013" transform="rotate(-180 34.4563 35.4561)" fill="white" fill-opacity="0.5"/><circle cx="34.4563" cy="35.4561" r="32.1013" transform="rotate(-180 34.4563 35.4561)" stroke="#014548" stroke-width="3"/></g><g clip-path="url(#clip0_9117_19427)"><path d="M22.1449 36.4439L38.796 53.049C39.3416 53.5927 40.2248 53.5918 40.7695 53.0461C41.3137 52.5006 41.3123 51.6168 40.7666 51.0727L25.1067 35.456L40.7672 19.8394C41.3128 19.2952 41.3142 18.412 40.77 17.8663C40.497 17.5928 40.1393 17.4561 39.7816 17.4561C39.4249 17.4561 39.0686 17.5919 38.7961 17.8635L22.1449 34.4681C21.8822 34.7295 21.7347 35.0853 21.7347 35.456C21.7347 35.8267 21.8826 36.182 22.1449 36.4439Z" fill="#014548"/></g><defs><filter id="filter0_b_9117_19427" x="-9.34502" y="-8.34526" width="87.6026" height="87.6026" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="5.1"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_9117_19427"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9117_19427" result="shape"/></filter><clipPath id="clip0_9117_19427"><rect width="36" height="36" fill="white" transform="translate(49.4561 53.4561) rotate(-180)"/></clipPath></defs></svg></button>',
  nextArrow: '<button type="button" class="slider-button slider-button--next pdp_desktop_slider_icons"><svg xmlns="http://www.w3.org/2000/svg" width="69" height="70" viewBox="0 0 69 70" fill="none"><g filter="url(#filter0_b_9117_19411)"><circle cx="34.5439" cy="34.5439" r="33.6013" fill="white" fill-opacity="0.5"/><circle cx="34.5439" cy="34.5439" r="32.1013" stroke="#014548" stroke-width="3"/></g><g clip-path="url(#clip0_9117_19411)"><path d="M46.8551 33.5561L30.204 16.951C29.6584 16.4073 28.7752 16.4082 28.2305 16.9539C27.6863 17.4994 27.6877 18.3832 28.2334 18.9273L43.8933 34.544L28.2328 50.1606C27.6872 50.7048 27.6858 51.588 28.23 52.1337C28.503 52.4072 28.8607 52.5439 29.2184 52.5439C29.5751 52.5439 29.9314 52.4081 30.2039 52.1365L46.8551 35.5319C47.1178 35.2705 47.2653 34.9147 47.2653 34.544C47.2653 34.1733 47.1174 33.818 46.8551 33.5561Z" fill="#014548"/></g><defs><filter id="filter0_b_9117_19411" x="-9.25737" y="-9.25737" width="87.6026" height="87.6026" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="5.1"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_9117_19411"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9117_19411" result="shape"/></filter><clipPath id="clip0_9117_19411"><rect width="36" height="36" fill="white" transform="translate(19.5439 16.5439)"/></clipPath></defs></svg></button>',
  responsive: [
    {
      // Tablet view (991px and below)
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        prevArrow: '<button type="button" class="slider-button slider-button--prev pdp_desktop_slider_icons"><svg xmlns="http://www.w3.org/2000/svg" width="69" height="70" viewBox="0 0 69 70" fill="none"><g filter="url(#filter0_b_9117_19427)"><circle cx="34.4563" cy="35.4561" r="33.6013" transform="rotate(-180 34.4563 35.4561)" fill="white" fill-opacity="0.5"/><circle cx="34.4563" cy="35.4561" r="32.1013" transform="rotate(-180 34.4563 35.4561)" stroke="#014548" stroke-width="3"/></g><g clip-path="url(#clip0_9117_19427)"><path d="M22.1449 36.4439L38.796 53.049C39.3416 53.5927 40.2248 53.5918 40.7695 53.0461C41.3137 52.5006 41.3123 51.6168 40.7666 51.0727L25.1067 35.456L40.7672 19.8394C41.3128 19.2952 41.3142 18.412 40.77 17.8663C40.497 17.5928 40.1393 17.4561 39.7816 17.4561C39.4249 17.4561 39.0686 17.5919 38.7961 17.8635L22.1449 34.4681C21.8822 34.7295 21.7347 35.0853 21.7347 35.456C21.7347 35.8267 21.8826 36.182 22.1449 36.4439Z" fill="#014548"/></g><defs><filter id="filter0_b_9117_19427" x="-9.34502" y="-8.34526" width="87.6026" height="87.6026" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="5.1"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_9117_19427"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9117_19427" result="shape"/></filter><clipPath id="clip0_9117_19427"><rect width="36" height="36" fill="white" transform="translate(49.4561 53.4561) rotate(-180)"/></clipPath></defs></svg></button>',
        nextArrow: '<button type="button" class="slider-button slider-button--next pdp_desktop_slider_icons"><svg xmlns="http://www.w3.org/2000/svg" width="69" height="70" viewBox="0 0 69 70" fill="none"><g filter="url(#filter0_b_9117_19411)"><circle cx="34.5439" cy="34.5439" r="33.6013" fill="white" fill-opacity="0.5"/><circle cx="34.5439" cy="34.5439" r="32.1013" stroke="#014548" stroke-width="3"/></g><g clip-path="url(#clip0_9117_19411)"><path d="M46.8551 33.5561L30.204 16.951C29.6584 16.4073 28.7752 16.4082 28.2305 16.9539C27.6863 17.4994 27.6877 18.3832 28.2334 18.9273L43.8933 34.544L28.2328 50.1606C27.6872 50.7048 27.6858 51.588 28.23 52.1337C28.503 52.4072 28.8607 52.5439 29.2184 52.5439C29.5751 52.5439 29.9314 52.4081 30.2039 52.1365L46.8551 35.5319C47.1178 35.2705 47.2653 34.9147 47.2653 34.544C47.2653 34.1733 47.1174 33.818 46.8551 33.5561Z" fill="#014548"/></g><defs><filter id="filter0_b_9117_19411" x="-9.25737" y="-9.25737" width="87.6026" height="87.6026" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="5.1"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_9117_19411"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9117_19411" result="shape"/></filter><clipPath id="clip0_9117_19411"><rect width="36" height="36" fill="white" transform="translate(19.5439 16.5439)"/></clipPath></defs></svg></button>',
      }
    },
    {
      // Mobile view (768px and below)
      breakpoint: 950, 
      settings: {
        slidesToShow: 2,
        prevArrow: '<button type="button" class="slick-prev pdp_mobile_slider_icons"><svg width="13" height="28" viewBox="0 0 13 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5526 1L1.5212 13.6708L11.5526 26.3415" stroke="#CD6B84" stroke-width="2" stroke-linecap="round"/></svg></button>',
       nextArrow: '<button type="button" class="slick-next pdp_mobile_slider_icons"><svg width="14" height="28" viewBox="0 0 14 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.96814 1L11.9996 13.6708L1.96814 26.3415" stroke="#CD6B84" stroke-width="2" stroke-linecap="round"/></svg></button>',
      }
    },
    {
      // Mobile landscape (427px and below)
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        prevArrow: '<button type="button" class="slick-prev pdp_mobile_slider_icons"><svg width="13" height="28" viewBox="0 0 13 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5526 1L1.5212 13.6708L11.5526 26.3415" stroke="#CD6B84" stroke-width="2" stroke-linecap="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next pdp_mobile_slider_icons"><svg width="14" height="28" viewBox="0 0 14 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.96814 1L11.9996 13.6708L1.96814 26.3415" stroke="#CD6B84" stroke-width="2" stroke-linecap="round"/></svg></button>',
      }
    }
  ]
});

//end key ingredients

// subscribe now - popup open
document.addEventListener("DOMContentLoaded", function(){
  let subscribeBtn = document.querySelector('.subscribe-now');
  subscribeBtn?.addEventListener("click",()=>{
          let popUp = document.querySelector('.popup-partition');
          popUp.style.display = "flex";
          document.querySelector('.cross-btn').addEventListener('click', function() {
              popUp.style.display = "none";
          });
      })
});


//background-color for article carts
  const bg_colors = ["#EBE2FF", "#E2F1FF", "#FFE2E9"];
  const divs = document.querySelectorAll(".blog-article-card.article");

  divs.forEach((div, index) => {
    div.style.backgroundColor = bg_colors[index % bg_colors.length];
  });

document.addEventListener("DOMContentLoaded", function () {
          const wishlistItems = document.querySelectorAll(".wishlist-heart-icon");
      
          wishlistItems.forEach((item) => {
              item.addEventListener("click", function () {
                if(item.classList.contains("inWishlist")){
                  item.classList.remove("inWishlist")
                }else{
                  item.classList.add("inWishlist")
                }

                  const productId = item.getAttribute("productId");
                  let productIds = JSON.parse(localStorage.getItem('productIds')) || [];

                  if (productIds.includes(productId)) {
                      productIds = productIds.filter(id => id !== productId);
                  } else {
                      productIds.push(productId);
                  }
                  localStorage.setItem('productIds', JSON.stringify(productIds));
              });
          });
                 var getIds = localStorage.getItem("productIds");
      var productIdsArray = JSON.parse(getIds) || [];
      wishlistItems.forEach((item)=>{
        if(item){
          const productId = item.getAttribute("productId")
          productIdsArray.map((inLocal)=>{
          if(inLocal === productId ){
            item.classList.add("inWishlist")
          }
          })

        }
      })

      });
    